// Live clock block for the login brand panel: current time, weekday + solar
// date (dd/mm/yyyy), and the matching Vietnamese lunar date. It re-renders on
// its own right after each minute boundary, so the rest of the panel (logo,
// intro, quote) never re-renders because of the clock.
import { format } from "date-fns";
import { vi } from "date-fns/locale";
import { useEffect, useState } from "react";
import { formatLunarDate, lunarDateOf } from "./lunar-calendar";

const MS_PER_MINUTE = 60_000;

/** "Chủ Nhật, 13/09/2026" — weekday from date-fns' vi locale, date per the project rule. */
function formatSolarLine(d: Date): string {
  return format(d, "EEEE, dd/MM/yyyy", { locale: vi });
}

export function LoginClock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    // Wake up 50 ms after the next minute boundary, then keep doing so.
    const schedule = () => {
      timer = setTimeout(
        () => {
          setNow(new Date());
          schedule();
        },
        MS_PER_MINUTE - (Date.now() % MS_PER_MINUTE) + 50,
      );
    };
    schedule();
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative">
      <time
        dateTime={now.toISOString()}
        className="block text-[64px] font-normal leading-none tracking-[-0.02em] lg:text-[104px]"
        style={{ fontFamily: "var(--font-numeral)" }}
      >
        {format(now, "HH:mm")}
      </time>
      <p className="m-0 mt-2 text-[15px] lg:text-[17px]">{formatSolarLine(now)}</p>
      <p className="m-0 mt-1 text-[13px] lg:text-[14px]">
        Âm lịch: {formatLunarDate(lunarDateOf(now))}
      </p>
    </div>
  );
}
